import React, { useState, useEffect, useRef } from "react";
import { useLoading } from "../../../contexts/LoadingContext";
import handleApiResponse from "../../../utils/handleApiResponse";
import IApiResponse from "../../../types/IApiResponse";
import { postData } from "../../../services/api";
import apiUrls from "../../../config/apiUrls";
import { IClubData, ITeamData, ITeams } from "../../../types/IPlayerDetail";
import LabelText from "../../../ui/LabelText";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import ClubsInfo from "../../ClubsInfo";
import { FilterSectionStyles, SortDropdown } from "../../../styled-components/FilterStyles";
import { StyledHeader } from "../../ClubDetail/ClubFinancial/ClubFinancial";
import ClubSearchFilter from "../../ClubLanding/ClubSearch/ClubSearchFilter";
import SecondaryButton from "../../../ui/SecondaryButton";
import FilterSort from "../../PlayerLanding/PlayerSearch/FilterSort";
import { useClubSearch } from "../../../contexts/ClubSearchContext";
import { useNotification } from "../../../contexts/NotificationContext";
import PWNotification from "../../PWNotification";
import { BorderLinearProgress } from "../../PlayerLanding/PlayerSearch/PlayerFilterResultsPage";
import MachineFootballIcon from "../../../assets/sidebarIcons/MachineFootballIcon.png";
import { useNavigate } from "react-router-dom";
import ClubFilterSection from "../../ClubSearch/ClubFilterSection";
import ClubCandidateFilterSection from "./ClubCandidateFilterSection";
import PaginationComponent from "../../../ui/PaginationComponent";
import { usePlayerSearch } from "../../../contexts/SearchPlayersContext";

interface CandidateProps {
  playerId: number;
  playerClubURL: string;
}

const Candidate: React.FC<CandidateProps> = ({ playerId, playerClubURL }) => {
  //   const { startLoading, stopLoading } = useLoading();

  const { showNotification, hideNotification, displayNotification, setDisplayNotification, notificationContent, setNotificationContent } = useNotification();

  const { regionAreaCandidateData, setRegionAreaCandidateData, setClubRegionCandidateValues, clubRegionCandidateValues,totalCandidateRevenue, 
    totalCandidateCost, totalCandidateProfitLoss, totalCandidateDebt, totalIntangibleCandidateAssets, retainedCandidateEraning, 
    totalCandidateReceivables, receivablesCandidatePercentage,avgSquadCandidateValue,avgCandidateSystemFit,avgCandidatePlayerAge,
    setClubCurrentCandidatePage, setTotalCandidateRevenue, setTotalCandidateCost, setTotalCandidateProfitLoss, setTotalIntangibleCandidateAssets, 
    setTotalCandidateDebt, setTotalCandidateReceivables,setReceivablesCandidatePercentage,isClubCandidateFilterChange, setIsClubCandidateFilterChange, 
    setRetainedCandidateEraning, debtVsAssetsCandidateRatio, setDebtVsAssetsCandidateRatio , minMaxCandidateData ,setMinMaxCandidateData , 
    setAvgSquadCandidateValue ,setAvgCandidateSystemFit,setAvgCandidatePlayerAge,includeCandidateFinancial , setInculdeCandidateFinancial , 
    wholeCandidateSquad , setWholeCandidateSquad , sortClubCandidateOrdering, sortClubCandidateOrderName , clubCurrentCandidatePage
    ,squadPurchaseCandidateCostVSValue, setSquadPurchaseCandidateCostVSValue , toggles, setToggles } = useClubSearch();

  const {isAffordabilityFilter, setIsAffordabilityFilter,isStylisticFilter, setIsStylisticFilter} = usePlayerSearch();
  const [playerClubResults, setplayerClubResults] = useState<ITeams[]>([]);
  const [playerResultsCount, setPlayerResultsCount] = useState(0);
  const [isPageChange, setIsPageChange] = useState<boolean>(false);
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [openIndex, setOpenIndex] = useState(0);
  const [isSortClicked, setIsSortClicked] = useState(false);
  const filterSortRef = useRef<HTMLDivElement | null>(null);
  const [teamIds, setTeamIds] = useState<number[]>([]);
  const [clubResultsCount, setClubResultsCount] = useState(0);
  const [clubCurrentPage, setClubCurrentPage] = useState<number>(1);
  const [loadingProgressValue, setLoadingProgressValue] = useState<number>(0);
  const [isPlayerResultsLoading, setIsPlayerResultsLoading] = useState<boolean>(false);
  const [subProcessIndex, setSubProcessIndex] = useState<number>(0);
  const pageSize = 20;
  const totalPages = Math.ceil(clubResultsCount / pageSize);
  const hasFetched = useRef(false);
  const subProcesses = [
    "Retrieving club metadata to create the list",
    "Performing vector search for similarity",
    "Applying filters",
    "Sorting the data",
    "Nearly complete",
  ];
  const filterToggles = {
    affordability: true,
    wageOutlier: true,
    leagueWeighting: true,
    stylisticFit: true,
    systemFit: true,
  };
  const navigate = useNavigate();

  const sortByData = ["Predicted system fit uplift", "System Fit", "Affordability", "Performance uplift", "Average wage" , "Stylistic fit uplift"];

  const handleSortChange = () => {
    setIsSortClicked(false);
    setIsClubCandidateFilterChange(true);
  };

  useEffect(() => {
      const sortResults = (results: any, key: any) => {
          return [...results].sort((a, b) => {
            if (sortClubCandidateOrdering === "ASC") {
              return (a[key] ?? 0) - (b[key] ?? 0);
            } else if (sortClubCandidateOrdering === "DESC") {
              return (b[key] ?? 0) - (a[key] ?? 0);
            } else {
              return 0;
            }
          });
      };
      if (playerClubResults) {
          //   startLoading();
          let sortedResults = [];
          if (sortClubCandidateOrderName === "Predicted system fit uplift") {
            sortedResults = sortResults(playerClubResults, "partnershipScoreDifference");
          } else if (sortClubCandidateOrderName === "Performance uplift") {
            sortedResults = sortResults(playerClubResults, "performanceUplift");
          } else if (sortClubCandidateOrderName === "System Fit") {
            sortedResults = sortResults(playerClubResults, "systemFit");
          } else if (sortClubCandidateOrderName === "Average wage") {
            sortedResults = sortResults(playerClubResults, "averageWage");
          } else if (sortClubCandidateOrderName === "Affordability") {
            sortedResults = sortResults(playerClubResults, "affordability");
          }
          setplayerClubResults(sortedResults!);
          //   setTimeout(() => {
          //     stopLoading();
          //   }, 100);
        }
  }, [sortClubCandidateOrdering, sortClubCandidateOrderName]);

  useEffect(() => {
      const handleClickOutside = (event: MouseEvent) => {
        if (filterSortRef.current && !filterSortRef.current.contains(event.target as Node)) {
          setIsSortClicked(false);
        }
      };
      document.addEventListener("mousedown", handleClickOutside);
      return () => {
        document.removeEventListener("mousedown", handleClickOutside);
      };
  }, [filterSortRef]);

  // useEffect(() => {
  //   const fetchPlayerClubResults = async () => {
  //     try {
  //       const ApiRequestData = {
  //         playerId: playerId,
  //         minWageCap: 0,
  //         maxWageCap: 0,
  //         areaId: [0],
  //         pageNo: currentPage,
  //       };
  //       const response: IApiResponse<IClubData> = await postData(apiUrls.TeamsRecommendation, ApiRequestData);
  //       handleApiResponse(
  //         response,
  //         (clubData) => {
  //           if (clubData && clubData.count && clubData.teams && clubData.teams.length > 0) {
  //             setDisplayNotification(false);
  //             setNotificationContent(null);
  //             setplayerClubResults(clubData.teams);
  //             setPlayerResultsCount(clubData.count);
  //             setIsPageChange(false);
  //             setTeamIds(clubData.teamIds);
  //           } else {
  //             setSubProcessIndex(4);
  //             setLoadingProgressValue(100);
  //             setTimeout(() => setIsPlayerResultsLoading(false), 1000);
  //             setTimeout(() => setDisplayNotification(true), 1000);
  //             setNotificationContent(
  //               <div className="notification">
  //                 <InfoOutlinedIcon className="icon" />
  //                 <p>
  //                   <LabelText className="squad-chart-tooltip notification-content">No results found -</LabelText>
  //                   <LabelText className="player-given-name notification-content"> Try adjusting the filters</LabelText>
  //                 </p>
  //               </div>
  //             );
  //           }
  //         },
  //         (error) => {
  //           console.log(" Error fetching TeamsRecommendation Data", error);
  //           setSubProcessIndex(4);
  //           setLoadingProgressValue(100);
  //           setTimeout(() => setIsPlayerResultsLoading(false), 1000);
  //           setTimeout(() => setDisplayNotification(true), 1000);
  //           setNotificationContent(
  //             <div className="notification">
  //               <InfoOutlinedIcon className="icon" />
  //               <p>
  //                 <LabelText className="squad-chart-tooltip notification-content">No results found -</LabelText>
  //                 <LabelText className="player-given-name notification-content"> Try adjusting the filters</LabelText>
  //               </p>
  //             </div>
  //           );
  //         }
  //       );
  //     } catch (error) {
  //       setSubProcessIndex(4);
  //       setLoadingProgressValue(100);
  //       setTimeout(() => setIsPlayerResultsLoading(false), 1000);
  //       console.error("Error fetching TeamsRecommendation data:", error);
  //     }
  //   };
  //   fetchPlayerClubResults();
  // }, [playerId, currentPage, isPageChange]);

  const fetchPlayerClubResults = async () => {
        // Start loading
        setIsPlayerResultsLoading(true);
        setLoadingProgressValue(0);
        setSubProcessIndex(0);

        // Progressive loading simulation (up to 80%)
        let progress = 0;
        let subIndex = 0;
        const intervalId = setInterval(() => {
          setLoadingProgressValue((prev) => {
            progress = prev + 20;
            if (progress >= 80) {
              clearInterval(intervalId);
              return prev;
            }
            return progress;
          });

          setSubProcessIndex((prev) => {
            subIndex = prev < 4 ? prev + 1 : 4;
            return subIndex;
          });
        }, 5000);

      try {
          setDisplayNotification(false)
          const areaValues = clubRegionCandidateValues.map((reg) => reg.optionId);
          const ApiRequestData = {
            playerId : playerId,
            includeAffordability: toggles.affordability,
            includeExceedsHighestWage: toggles.wageOutlier,
            adjustLeagueWeighting: toggles.leagueWeighting,
            includeOnlyPositiveStylisticFitUplift: toggles.stylisticFit,
            includeOnlyPositiveSystemFitUplift: toggles.systemFit,
            areaId: areaValues,
            competitionId: [],
            minTotalRevenue: totalCandidateRevenue.min,
            maxTotalRevenue: totalCandidateRevenue.max, 
            minTotalCost: totalCandidateCost.min, 
            maxTotalCost: totalCandidateCost.max, 
            minTotalProfitLoss: totalCandidateProfitLoss.min, 
            maxTotalProfitLoss: totalCandidateProfitLoss.max, 
            minTotalDebt: totalCandidateDebt.min, 
            maxTotalDebt: totalCandidateDebt.max, 
            minRetainedEarnings: retainedCandidateEraning.min, 
            maxRetainedEarnings: retainedCandidateEraning.max, 
            minDebtVsAssetsRatio: debtVsAssetsCandidateRatio.min, 
            maxDebtVsAssetsRatio: debtVsAssetsCandidateRatio.max, 
            minTotalIntangibleAssets: totalIntangibleCandidateAssets.min, 
            maxTotalIntangibleAssets: totalIntangibleCandidateAssets.max, 
            minTotalReceivables: totalCandidateReceivables.min, 
            maxTotalReceivables: totalCandidateReceivables.max, 
            minReceivablesPercentage: receivablesCandidatePercentage.min, 
            maxReceivablesPercentage: receivablesCandidatePercentage.max, 
            minAvSquadValue: avgSquadCandidateValue.min, 
            maxAvSquadValue: avgSquadCandidateValue.max, 
            minAvSystemFit: avgCandidateSystemFit.min, 
            maxAvSystemFit: avgCandidateSystemFit.max, 
            minAvPlayerAge: avgCandidatePlayerAge.min, 
            maxAvPlayerAge: avgCandidatePlayerAge.max, 
            minPurchaseVsMarketValue: squadPurchaseCandidateCostVSValue.min, 
            maxPurchaseVsMarketValue: squadPurchaseCandidateCostVSValue.max, 
            // maxSquadPurchaceAndCurrentRatio: 0, 
            // minSquadPurchaceAndCurrentRatio: 0, 
            // isPurchaseVsMarketValueWhole: true,
            orderName: sortClubCandidateOrderName,
            ordering: sortClubCandidateOrdering,
            // pageNo: clubCurrentCandidatePage,
            pageSize: 2500,
          };
          const response: IApiResponse<ITeamData> = await postData(apiUrls.ClubCandidates, ApiRequestData);

          handleApiResponse(
            response,
            (clubData) => {
              clearInterval(intervalId); // stop progressive loading
              setTimeout(() => setIsPlayerResultsLoading(false), 1000);
              if (clubData?.teams && clubData.teams.length > 0) {
                setDisplayNotification(false)
                setClubResultsCount(clubData?.count);
                setTeamIds(clubData?.teamIds)
                setplayerClubResults(clubData.teams);
                setSubProcessIndex(4);
                setLoadingProgressValue(100);
              } else {
                // Empty but valid response
                setplayerClubResults([]);
                setSubProcessIndex(4);
                setLoadingProgressValue(100);
                // setIsPlayerResultsLoading(false);

                setTimeout(() => setDisplayNotification(true), 1000);
                setNotificationContent(
                  <div className="notification">
                    <InfoOutlinedIcon className="icon" />
                    <p>
                      <LabelText className="squad-chart-tooltip notification-content">No results found -</LabelText>
                      <LabelText className="player-given-name notification-content">Try adjusting the filters</LabelText>
                    </p>
                  </div>
                );
              }
              setIsClubCandidateFilterChange(false);
            },
            (error) => {
              clearInterval(intervalId); // stop progressive loading
              console.log("Error fetching TeamsRecommendation Data", error);
              setIsClubCandidateFilterChange(false);
              setSubProcessIndex(4);
              setLoadingProgressValue(100);
              setIsPlayerResultsLoading(false);

              setDisplayNotification(true);
              setNotificationContent(
                <div className="notification">
                  <InfoOutlinedIcon className="icon" />
                  <p>
                    <LabelText className="squad-chart-tooltip notification-content">No results found -</LabelText>
                    <LabelText className="player-given-name notification-content">Try adjusting the filters</LabelText>
                  </p>
                </div>
              );
            }
          );
        } catch (error) {
          setDisplayNotification(true)
          clearInterval(intervalId); // stop progressive loading
          console.error("Error fetching ClubCandidates data:", error);
          setSubProcessIndex(4);
          setLoadingProgressValue(100);
          setIsPlayerResultsLoading(false);
        }
    };

    useEffect(() => {
  if (isClubCandidateFilterChange) {
    // if (hasFetched.current) {
    //   // ✅ Prevent duplicate call in StrictMode
    //   return;
    // }

    fetchPlayerClubResults();
    // hasFetched.current = true;
  }
},[playerId ,isClubCandidateFilterChange ,toggles.affordability,toggles.wageOutlier,toggles.leagueWeighting,toggles.stylisticFit,toggles.systemFit,
      totalCandidateRevenue , totalCandidateProfitLoss , totalCandidateDebt,
      retainedCandidateEraning,debtVsAssetsCandidateRatio,totalIntangibleCandidateAssets,totalCandidateReceivables,receivablesCandidatePercentage,
      avgSquadCandidateValue,avgCandidateSystemFit,avgCandidatePlayerAge,squadPurchaseCandidateCostVSValue,clubRegionCandidateValues,
      sortClubCandidateOrderName,sortClubCandidateOrdering])

      const handleToggle = (index: number) => {
        setOpenIndex((prevIndex) => (prevIndex === index ? -1 : index));
      };

      const handlePageChange = (page: number) => {
            // setIsClubCandidateFilterChange(true);
            // setIsPlayerResultsLoading(true)
            setClubCurrentCandidatePage(page);
      };
      const paginatedResults = playerClubResults.slice(
      (clubCurrentCandidatePage - 1) * pageSize,
      clubCurrentCandidatePage * pageSize
    );

  const renderClubResults = () => {
    return (
      <>
        {paginatedResults?.map((clubData: ITeams, index: number) => (
          <div className="player-card-wrapper" key={clubData.team.teamId}>
            <ClubsInfo
              clubData={clubData}
              isOpen={openIndex === index}
              onToggle={(event: React.MouseEvent) => {
                event.stopPropagation();
                handleToggle(index);
              }}
              playerData={{ playerId: playerId, playerClubURL: playerClubURL }}
              type="candidate"
            />
          </div>
        ))}
         {totalPages > 0 && paginatedResults.length > 0 && (
              <div className="pagination-wrapper">
                  <PaginationComponent
                      totalPages={totalPages}
                      currentPage={clubCurrentCandidatePage}
                      onPageChange={handlePageChange}
                  />
              </div>
          )}
      </>
    );
  };

  // useEffect(() => {
  //   if (playerClubResults?.length === 0) {
  //     setIsPlayerResultsLoading(true);
  //     const intervalId = setInterval(() => {
  //       setLoadingProgressValue((prev) => {
  //         if (prev >= 80) {
  //           clearInterval(intervalId);
  //           return prev;
  //         }
  //         return prev + 20;
  //       });
  //       setSubProcessIndex((prev) => {
  //         if (prev < 4) {
  //           return prev + 1;
  //         } else {
  //           return 4;
  //         }
  //       });
  //     }, 5000);
  //     return () => clearInterval(intervalId);
  //   } else {
  //     setSubProcessIndex(4);
  //     setLoadingProgressValue(100);
  //     setIsPlayerResultsLoading(false);
  //     // setTimeout(() => setIsPlayerResultsLoading(false), 1000);
  //   }
  // }, [playerClubResults]);

  const handleClubComparision = () => {
    localStorage.removeItem("removedclubIds");
    navigate(`/clubcomparison`, { state: { teamIds, isFromSortList: false } });
  };

  useEffect(()=>{
    setIsClubCandidateFilterChange(true);
    setToggles(filterToggles)
    setIsAffordabilityFilter(true)
    setIsStylisticFilter(true)
  },[playerId])

  

  return (
    <>
      <FilterSectionStyles className="filters-section">
        <ClubCandidateFilterSection/>
      </FilterSectionStyles>
      <div className="results-section tab-content-right">
        <div className="header-content-wrapper">
          <StyledHeader className="header-content">
            <LabelText className="player-family-name">Results</LabelText>
            <div style={{ display: "flex" }}>
              <SecondaryButton
                iconType="sort"
                label={
                  <>
                    <span className="sort-label">Sort by: </span>
                    <LabelText className="clear-labeltext">{sortClubCandidateOrderName}</LabelText>
                  </>
                }
                onClick={() => setIsSortClicked((prev) => !prev)}
              />
              {isSortClicked && (
                <SortDropdown ref={filterSortRef} className="newplayer-brop">
                  <FilterSort onSortChange={handleSortChange} data={sortByData} sortType={"clubCandidate"} />
                </SortDropdown>
              )}
              <div className="comparision-action-div">
                <SecondaryButton
                  iconType="playercomparison"
                  label="Comparison tools"
                  className="comparision-tools-btn"
                  onClick={handleClubComparision}
                />
              </div>
            </div>
          </StyledHeader>
        </div>
        {isPlayerResultsLoading && (
          <div className="playerresults-loader">
            <div className="loader-header-container">
              <p>Creating list</p>
              <img src={MachineFootballIcon} className="mf-logo" alt="machine-football-logo" />
            </div>
            <div className="loader-progressbar-container">
              <BorderLinearProgress variant="determinate" value={loadingProgressValue} />
            </div>
            <div className="loader-subprocess">
              {subProcesses[subProcessIndex]}
              <p>{loadingProgressValue}%</p>
            </div>
          </div>
        )}
        {renderClubResults()}
        {displayNotification && (
          <PWNotification
            message={notificationContent}
            setIsNotification={() => setDisplayNotification(false)}
            isDisplayCloseIcon={false}
            className="player-filter-notification"
          />
        )}
      </div>
    </>
  );
};

export default Candidate;
